module.exports = {
	"header.logo.title": "GROHE - Pure Freude an Wasser",
	"footer.privacy.text": "Privacy",
	"footer.privacy.url": "https://www.grohe.bg/bg_bg/company/privacy/",
	"footer.disclaimer.text": "Disclaimer",
	"footer.disclaimer.url": "https://www.grohe.bg/bg_bg/company/legal-info/",
	"footer.copyright": "&copy; 2017 GROHE Limited",
	"homepage.headline": "GROHE WaterSystems Configurator",
	"homepage.introtext": "Отговорете на няколко въпроса и открийте най-подходящата за вас GROHE Watersystem, която ще отговори на вашите нужди.",
	"homepage.buttonStart": "Начало",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"404.title": "404 Page Not Found",
	"404.link.goBack": "Обратно към началото",
	"configurator.button.seeResults": "Към резултата",
	"question1.question": "Имате ли водоснабдяване с топла и студена вода в кухнята си?",
	"question1.option1.text": "Имам студена и топла вода в кухнята си.",
	"question1.option2.text": "Имам само студена вода в кухнята си.",
	"question2.question": "Какъв вид вода желаете?",
	"question2.option1.text": "Вряла вода за приготвяне на храна и напитки",
	"question2.option2.text": "Охладена и газирана вода за пиене",
	"question2.option3.text": "Охладелна и газирана, както и вряла вода",
	"question3.question": "Искате ли да запазите настоящия си кухненски смесител?",
	"question3.option1.text": "Искам да го запазя",
	"question3.option2.text": "Искам да инсталирам нов модел",
	"question4.question": "Кой бихте искали да е главният ви смесител?",
	"question4.option1.text": "GROHE Blue Home",
	"question4.option2.text": "GROHE Red",
	"question5.question": "Какъв дизайн на чучура предпочитате?",
	"question5.option1.text": "L-образен чучур",
	"question5.option2.text": "U-образен чучур",
	"question5.option3.text": "C-образен чучур",
	"question6.question": "Какво покритие предпочитате?",
	"question6.option1.text": "Хром",
	"question6.option2.text": "Supersteel",
	"question7.question": "Какъв размер бойлер бихте желали?",
	"question7.option1.text": "Размер M (3 литра)",
	"question7.option2.text": "Размер L (5.5 литра)",
	"results.title": "{productGroupsCount, plural, \none {Вашият резултат} \nother {Вашият резултат}\n}",
	"results.proposal.title": "Proposal {number}",
	"results.proposal.title.single": "Proposal",
	"results.bundle.title": "За правилна инсталация ще ви трябват още:",
	"results.newConfiguration.title": "Искате ли да конфигурирате нова система?",
	"results.newConfiguration.buttonText": "Конфигурирай нова сисмтема",
	"results.product.number": "Артикулен номер: #{number}",
	"results.product.button.productInformation": "Информация за продукта",
	"results.product.button.dealerLocator": "Намерете шоурум",
	"results.product.button.buyNow": "Buy Now",
	"results.product.button.downloadPDF": "Download PDF",
	"results.product.information": "Информация за продукта",
	"results.product.dealer": "Намерете шоурум",
	"hatchModal.title": "Buy online",
	"hatchModal.btnText": "Buy Online",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now"
};


//////////////////
// WEBPACK FOOTER
// ./src/translations/water.bg_bg.json
// module id = 770
// module chunks = 0